import http from "src/config/interceptors"

export const getMegaLiveUser = () => {
  const url = "/shop/shop-management/mega-lives/find-by-user"
  return http.get(url)
}
